import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Eager-load common namespace for all languages
import enCommon from './locales/en/common.json';
import elCommon from './locales/el/common.json';
import deCommon from './locales/de/common.json';
import esCommon from './locales/es/common.json';
import itCommon from './locales/it/common.json';
import trCommon from './locales/tr/common.json';

import enDashboard from './locales/en/dashboard.json';
import elDashboard from './locales/el/dashboard.json';
import deDashboard from './locales/de/dashboard.json';
import esDashboard from './locales/es/dashboard.json';
import itDashboard from './locales/it/dashboard.json';
import trDashboard from './locales/tr/dashboard.json';

import enAuth from './locales/en/auth.json';
import elAuth from './locales/el/auth.json';
import deAuth from './locales/de/auth.json';
import esAuth from './locales/es/auth.json';
import itAuth from './locales/it/auth.json';
import trAuth from './locales/tr/auth.json';

import enAccount from './locales/en/account.json';
import elAccount from './locales/el/account.json';
import deAccount from './locales/de/account.json';
import esAccount from './locales/es/account.json';
import itAccount from './locales/it/account.json';
import trAccount from './locales/tr/account.json';

import enLanding from './locales/en/landing.json';
import elLanding from './locales/el/landing.json';
import deLanding from './locales/de/landing.json';
import esLanding from './locales/es/landing.json';
import itLanding from './locales/it/landing.json';
import trLanding from './locales/tr/landing.json';

import enLegal from './locales/en/legal.json';
import elLegal from './locales/el/legal.json';
import deLegal from './locales/de/legal.json';
import esLegal from './locales/es/legal.json';
import itLegal from './locales/it/legal.json';
import trLegal from './locales/tr/legal.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, dashboard: enDashboard, auth: enAuth, account: enAccount, landing: enLanding, legal: enLegal },
      el: { common: elCommon, dashboard: elDashboard, auth: elAuth, account: elAccount, landing: elLanding, legal: elLegal },
      de: { common: deCommon, dashboard: deDashboard, auth: deAuth, account: deAccount, landing: deLanding, legal: deLegal },
      es: { common: esCommon, dashboard: esDashboard, auth: esAuth, account: esAccount, landing: esLanding, legal: esLegal },
      it: { common: itCommon, dashboard: itDashboard, auth: itAuth, account: itAccount, landing: itLanding, legal: itLegal },
      tr: { common: trCommon, dashboard: trDashboard, auth: trAuth, account: trAccount, landing: trLanding, legal: trLegal },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'el', 'de', 'es', 'it', 'tr'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
